var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImageClassification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2761 0.390524C30.7968 0.911223 30.7968 1.75544 30.2761 2.27614L21.8856 10.6667H25.3333C26.0697 10.6667 26.6667 11.2636 26.6667 12C26.6667 12.7364 26.0697 13.3333 25.3333 13.3333H17.3333V5.33333C17.3333 4.59695 17.9303 4 18.6667 4C19.403 4 20 4.59695 20 5.33333V8.78105L28.3905 0.390524C28.9112 -0.130175 29.7554 -0.130175 30.2761 0.390524Z",
    fill: "#1E63F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 8H2.66667V25.8824L11.3333 14.6667L17.8189 23.0597L21.3333 18.6667L29.3333 28.6667V8L32 5.33333V32H0V5.33333H14.6667V8Z",
    fill: "#1E63F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImageClassification);
export default __webpack_public_path__ + "static/media/icon-imageClassification.effe1b3c43cef071f6f9be0a2cfa256e.svg";
export { ForwardRef as ReactComponent };